import { Pipe, PipeTransform } from '@angular/core';
import { formatPhoneDisplay } from '../utils/phone.util';

@Pipe({ name: 'phone' })
export class PhonePipe implements PipeTransform {
	transform(value: string | null | undefined): string {
		return formatPhoneDisplay(value);
	}
}
